var map = {
	"./template.bet575": 1923,
	"./template.bet575.tsx": 1923,
	"./template.bet777": 1924,
	"./template.bet777.tsx": 1924,
	"./template.betgalaxy": 1925,
	"./template.betgalaxy.tsx": 1925,
	"./template.betprofessor": 1926,
	"./template.betprofessor.tsx": 1926,
	"./template.betroyale": 2032,
	"./template.betroyale.tsx": 2032,
	"./template.betstride": 1927,
	"./template.betstride.tsx": 1927,
	"./template.buffalobet": 1928,
	"./template.buffalobet.tsx": 1928,
	"./template.chromabet": 1929,
	"./template.chromabet.tsx": 1929,
	"./template.default": 183,
	"./template.default.tsx": 183,
	"./template.epicodds": 1930,
	"./template.epicodds.tsx": 1930,
	"./template.fiestabet": 1931,
	"./template.fiestabet.tsx": 1931,
	"./template.forsport": 2149,
	"./template.forsport.tsx": 2149,
	"./template.gigabet": 1932,
	"./template.gigabet.tsx": 1932,
	"./template.goldenbet888": 1933,
	"./template.goldenbet888.tsx": 1933,
	"./template.goldenrush": 1934,
	"./template.goldenrush.tsx": 1934,
	"./template.hyperbet": 1935,
	"./template.hyperbet.tsx": 1935,
	"./template.juicybet": 1936,
	"./template.juicybet.tsx": 1936,
	"./template.junglebet": 1937,
	"./template.junglebet.tsx": 1937,
	"./template.magnumbet": 1938,
	"./template.magnumbet.tsx": 1938,
	"./template.puntcity": 2150,
	"./template.puntcity.tsx": 2150,
	"./template.puntgenie": 1939,
	"./template.puntgenie.tsx": 1939,
	"./template.pyramidbet": 1940,
	"./template.pyramidbet.tsx": 1940,
	"./template.questbet": 1941,
	"./template.questbet.tsx": 1941,
	"./template.slambet": 1942,
	"./template.slambet.tsx": 1942,
	"./template.sterlingparker": 1943,
	"./template.sterlingparker.tsx": 1943,
	"./template.templebet": 1944,
	"./template.templebet.tsx": 1944,
	"./template.titanbet": 1945,
	"./template.titanbet.tsx": 1945,
	"./template.ts": 1000,
	"./template.vikingbet": 1946,
	"./template.vikingbet.tsx": 1946,
	"./template.volcanobet": 1947,
	"./template.volcanobet.tsx": 1947,
	"./template.wellbet": 2151,
	"./template.wellbet.tsx": 2151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2795;